import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ColorDepth,
  CustomerBrowserData,
  UserDevice,
  WindowSize
} from '@up/data';
import { ReplaySubject, from } from 'rxjs';
/**
 * Builds the Customer Browser data. This object is mandatory for 3DS V2.x.
 * Send it along with BOIPA request as JSON Object.
 */
@Injectable({ providedIn: 'root' })
export class CustomerBrowserService {
  private browserDataSubject = new ReplaySubject<CustomerBrowserData>(1);
  public customerBrowserData = this.browserDataSubject.asObservable();

  constructor(private http: HttpClient) {
    from(this.buildBrowserData()).subscribe((browserData) =>
      this.browserDataSubject.next(browserData)
    );
  }

  /**
   * Builds the Customer Browser data. This object is mandatory for 3DS V2.x.
   * Send it along with BOIPA request as JSON Object.
   */
  async buildBrowserData(): Promise<CustomerBrowserData> {
    const customerBrowser = {
      browserAcceptHeader: this.getBrowserAcceptedHeaders(),
      browserJavaEnabled: this.getBrowserJavaEnabled(),
      browserJavascriptEnabled: this.getBrowserJavascriptEnabled(),
      browserLanguage: this.getBrowserLanguage(),
      browserColorDepth: this.getBrowserColorDepth(),
      browserScreenHeight: this.getBrowserScreenHeight(),
      browserScreenWidth: this.getBrowserScreenWidth(),
      browserTZ: this.getBrowserTZ(),
      challengeWindowSize: this.getChallengeWindowSize()
    };

    const userAgent = this.getUserAgent();
    const userDevice = this.getUserDevice();
    const customerIPAddress = await this.getCustomerIPAddress();

    return { customerBrowser, userAgent, userDevice, customerIPAddress };
  }
  private getUserDevice(): UserDevice {
    const device = 'DESKTOP';
    return device;
  }

  private getUserAgent(): string {
    return navigator.userAgent;
  }

  private getBrowserAcceptedHeaders() {
    return '*/*';
  }

  private getBrowserJavaEnabled(): boolean {
    return navigator.javaEnabled();
  }

  private getBrowserJavascriptEnabled(): boolean {
    return true;
  }

  private getBrowserLanguage(): string {
    return navigator.language;
  }

  private getBrowserColorDepth(): ColorDepth {
    const colorDepth = String(screen.colorDepth);
    if (this.isAllowedBrowserColorDepth(colorDepth)) {
      return colorDepth;
    }
    console.warn(`Unsupported colorDepth: ${colorDepth}. Defaulting to '24'.`);
    return '24';
  }

  private getBrowserScreenHeight(): number {
    return screen.height;
  }

  private getBrowserScreenWidth(): number {
    return screen.width;
  }

  private getBrowserTZ(): number {
    const timeZoneOffset = new Date().getTimezoneOffset();
    return Math.abs(timeZoneOffset);
  }

  private getChallengeWindowSize(): WindowSize {
    const fullScreen: WindowSize = '05';
    return fullScreen;
  }

  /**
   * Type guard for ColorDepth type.
   * @param value Color depth value.
   */
  private isAllowedBrowserColorDepth(value: string): value is ColorDepth {
    const allowedDepths: ColorDepth[] = [
      '1',
      '4',
      '8',
      '15',
      '16',
      '24',
      '32',
      '48'
    ];
    return allowedDepths.some((v) => v === value);
  }

  private async getCustomerIPAddress(): Promise<string> {
    try {
      const ipData = (await this.http
        .get('https://pie.up-co.com:3010/api/remote-sync/my-ip')
        .toPromise()) as any;
      return ipData?.ip;
    } catch (error) {
      console.error('ipData error', error);
      return '';
    }
  }
}
